import React, { useState } from 'react'
import Typography from '@mui/material/Typography'
// import Navbar from '../components/Navbar'
import PropTypes from 'prop-types'
import Appbar from '../components/Appbar'
import { Button, Box, Container, useTheme, useMediaQuery } from '@mui/material'
import LoginModal from '../components/modals/LoginModal'

const GetStarted = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const pageStyle = {
    background: {
      paddingTop: isMobile ? '56px' : '64px',
      bgcolor: '#EFF9FA',
      backgroundSize: '70px 70px',
      backgroundImage: 'radial-gradient(#444cf7 1px, #EFF9FA 1px)',
      opacity: 0.8
    },
    page: {
      height: isMobile ? 'calc(100vh - 56px)' : 'calc(100vh - 64px)',
      paddingTop: isMobile ? '56px' : '64px'
    },
    heroContainer: {
      maxWidth: '800px',
      m: 'auto',
      mt: '3em',
      dispaly: 'flex',
      alignItems: 'flex-start'
    }
  }
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false)

  const handleClick = () => {
    setIsLoginModalOpen(true)
  }
  const closeModals = () => {
    setIsLoginModalOpen(false)
  }

  return (
    <div style={pageStyle.background}>
      <Appbar />
      <Container sx={pageStyle.page}>
        <Box sx={pageStyle.heroContainer}>
          <Typography variant="h2" component="div" gutterBottom>
            Peace Game Simulations
          </Typography>
          <Typography variant="h3" gutterBottom></Typography>
          <Typography variant="h4" gutterBottom>
            An immersive AI-based assistance tool to analyze and accompany work
            for Conflict Resolution and Prevention.
          </Typography>
          <Button variant="contained" size="large" onClick={handleClick}>
            Sign In
          </Button>
        </Box>
      </Container>
      <LoginModal isOpen={isLoginModalOpen} handleClose={closeModals}>
        {' '}
      </LoginModal>
    </div>
  )
}

GetStarted.propTypes = {
  user: PropTypes.object
}

export default GetStarted
